module.exports = __webpack_public_path__ + "media/src/img/flags-1952df896c6a79bb730cdfb69adf4fa0.png";